// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1dGdJ","content":"LayoutSettings_content__3_dDV"};